import React from 'react'
import {
  Label,
  TableCell,
  TableRow,
} from 'semantic-ui-react'

const TransactionRow = ({
  bankTransfer,
  onRowClick,
  getBankTransferRowBgColor,
  // onSetBankTransferReconciledPress,
  index,
} = {}) => {
  // console.log('DID RENDER', index, bankTransfer.invoice0DeltaAmount)
  const {
    isBankTransferReconciled,
    isBankTransferMatched,
    status,
    calendarDateStr,
    label,
    bankTransferAmountFormattedString,
    invoice0DeltaAmount,
    reconciliationStatus,
    nbMatchedInvoices = 0,
  } = bankTransfer || {}
  if (label === 'VIR GLOBAL SAFETY NV 2025012269 VPUT-102500436') {
    console.log('Object.keys(bankTransfer)', Object.keys(bankTransfer))
  }

  return (
    <TableRow
      key={index}
      onClick={() => onRowClick(bankTransfer)}
      style={{
        cursor: "pointer",
        backgroundColor: getBankTransferRowBgColor(bankTransfer),
      }}
    >
      <TableCell className="transaction-cell">
        <div className="reconciled-cell">
          {nbMatchedInvoices === 0 ? '' : (
            `${invoice0DeltaAmount}` === '0' ? '☑️' : ''
          )}
        </div>
      </TableCell>
      <TableCell className="transaction-cell">
        <Label
          className="Matched-label"
          color={
            reconciliationStatus === 'reconciled'
              ? "custom-label-green"
              : (
                reconciliationStatus === 'matched' ? "custom-label-orange" : "custom-label-red"
              )
        }
        >
          {reconciliationStatus}
        </Label>
      </TableCell>
      <TableCell className="transaction-cell">
        {calendarDateStr}
      </TableCell>
      <TableCell className="transaction-cell">
        {label}
      </TableCell>
      <TableCell className="transaction-cell">
        {bankTransferAmountFormattedString}
      </TableCell>
    </TableRow>
  )
}

export default TransactionRow

// Example of little optimisation : memo used to prevent useless re-render
// export default memo(TransactionRow, (prevProps, nextProps) => {
//   const {
//     bankTransfer: prevTransfer,
//     getBankTransferRowBgColor: prevGetBgColor,
//   } = prevProps

//   const {
//     bankTransfer: nextTransfer,
//     getBankTransferRowBgColor: nextGetBgColor,
//   } = nextProps

//   const sameId = prevTransfer.id === nextTransfer.id
//   const sameDelta = prevTransfer.invoice0DeltaAmount === nextTransfer.invoice0DeltaAmount
//   const sameComment = prevTransfer.comment === nextTransfer.comment
//   const sameReconciled = prevTransfer.isBankTransferReconciled === nextTransfer.isBankTransferReconciled
//   const sameBgColor = prevGetBgColor(prevTransfer) === nextGetBgColor(nextTransfer)
//   const sameMatchedInvoices = isEqual(prevTransfer.matchedInvoices, nextTransfer.matchedInvoices)

//   return sameId
//     && sameDelta
//     && sameComment
//     && sameReconciled
//     && sameBgColor
//     && sameMatchedInvoices
// })
